// extracted by mini-css-extract-plugin
module.exports = {"container":"tableCells_container__14oEN","button":"tableCells_button__7Racz","pending":"tableCells_pending__1UkDd"};